import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { Dates } from '../../../store/models/dates';
import { IconNames, NOT_AVAILABLE } from '../../../common/constants';
import { LocalDate } from '../../../store/models/local-date.model';
import { DateType, TimeTitleKey } from '../../../store/constants';

@Component({
  selector: 'ui-dates',
  templateUrl: './dates.component.html',
  styleUrls: ['./dates.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DatesComponent {
  @Input() dates: Dates;
  @Input() dateType: DateType;

  iconNameList = IconNames;

  get time(): LocalDate {
    return this.dateType === DateType.Departure
      ? this.dates &&
          (this.dates.actualDepartureTime ?? this.dates.estimatedDepartureTime ?? this.dates.plannedDepartureTime)
      : this.dates &&
          (this.dates.actualArrivalTime ?? this.dates.estimatedArrivalTime ?? this.dates.plannedArrivalTime);
  }

  get timeTitleKey(): string {
    if (this.dateType === DateType.Departure) {
      switch (true) {
        case !!this.dates?.actualDepartureTime:
          return TimeTitleKey.ActualDepartureTime;
        case !!this.dates?.estimatedDepartureTime:
          return TimeTitleKey.EstimatedDepartureTime;
        case !!this.dates?.plannedDepartureTime:
          return TimeTitleKey.PlannedDepartureTime;
        default:
          return TimeTitleKey.PlannedDepartureTime;
      }
    } else {
      switch (true) {
        case !!this.dates?.actualArrivalTime:
          return TimeTitleKey.ActualArrivalTime;
        case !!this.dates?.estimatedArrivalTime:
          return TimeTitleKey.EstimatedArrivalTime;
        case !!this.dates?.plannedArrivalTime:
          return TimeTitleKey.PlannedArrivalTime;
        default:
          return TimeTitleKey.PlannedArrivalTime;
      }
    }
  }

  notAvailable = NOT_AVAILABLE;
  dateFormat: string;
}
